var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItemEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3L44 45M17.0267 18.015C16.2063 19.3557 15.861 20.9336 16.0465 22.4944C16.2319 24.0553 16.9373 25.5083 18.049 26.6195C19.1607 27.7307 20.6141 28.4353 22.175 28.62C23.736 28.8047 25.3136 28.4587 26.654 27.6377M30 21.6667C30 19.8102 29.2625 18.0297 27.9497 16.7169C26.637 15.4042 24.8565 14.6667 23 14.6667",
    stroke: "#969696",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7789 5.43136C17.3326 3.40775 21.4526 2.60717 25.5056 3.15268C29.5586 3.69818 33.3203 5.55958 36.2126 8.45079C39.1048 11.342 40.9676 15.103 41.5146 19.1558C42.0616 23.2086 41.2625 27.3289 39.2402 30.8834M35.0402 36.0307L26.3019 44.7667C25.4268 45.6408 24.2406 46.1319 23.0037 46.1319C21.7669 46.1319 20.5806 45.6408 19.7055 44.7667L9.80288 34.8664C6.50447 31.5685 4.56022 27.1552 4.35293 22.4956C4.14564 17.8359 5.69034 13.2674 8.68288 9.68969",
    stroke: "#969696",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemEmpty);
export default __webpack_public_path__ + "static/media/item-empty.d9a5c70092a302d428a8f8cb173e61ea.svg";
export { ForwardRef as ReactComponent };